// extracted by mini-css-extract-plugin
export default {"invitation-text":"lKgWG"};